<template>
  <div>
    <el-dialog title="服务内容" :visible="dialogVisible" width="50%" @close="handleCloseAdd('ruleForm')">
      <div class="content">
        <div style="float: right">
          <el-button icon="el-icon-plus" type="primary" size="small" @click="newAdd">添加</el-button>
        </div>
        <div>
          <div>
            <!-- 头部title -->
            <div class="first-title">
              <div class="first-title-icon"></div>
              <h1 class="first-title-word">自定义服务内容</h1>
            </div>
          </div>
          <el-table :data="tableData" style="width: 100%;overflow: auto">
            <el-table-column prop="id" label="id">
            </el-table-column>
            <el-table-column prop="title" label="服务名">
            </el-table-column>
            <el-table-column prop="status" label="服务状态">
              <template slot-scope="scope">
                {{ ['待上架', '已上架', '已下架'][scope.row.status] }}
              </template>
            </el-table-column>
            <el-table-column prop="serveStatus" label="上架">
              <template slot-scope="scope">
                <el-switch @change="changeStatus(scope.row)" v-model="scope.row.serveStatus" active-color="#13ce66"
                  inactive-color="#aaa">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="400">
              <template slot-scope="scope">
                <el-button icon="el-icon-edit" type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button icon="el-icon-delete" type="danger" size="mini" @click="del(scope.row)">删除</el-button>
                <el-button icon="el-icon-edit" type="primary" size="mini" @click="addServiceRules(scope.row)">添加服务规格</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageNo" :page-sizes="[10, 20, 30, 40]" :page-size="100"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAdd()">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </span>
    </el-dialog>
    <NewAdd @refersh="refersh" ref="newAdd" />
    <AddServiceRule @refersh="refersh" ref="AddServiceRule" :serviceId="serviceId"/>
  </div>
</template>

<script>
import NewAdd from './businessListingServesDialog.vue'
import AddServiceRule from './addServiceRule.vue'
export default {
  data() {
    return {
      dialogVisible: false,
      // 服务类型
      serveType: [],
      // 列表
      tableData: [],
      // 页码
      pageNo: 1,
      // 每页数量
      pageSize: 10,
      // 总条数
      total: 0,
      // 是否认是类型服务的评论
      status: '',
      busId: '',
      id: '',
      title: '',
      serviceId: '',
      img: '',
      money: '',
      shareMoney: '',

    };
  },
  mounted() {
  },
  components: {
    NewAdd,
    AddServiceRule
  },
  methods: {
    /**
     * 调整每天条数
     */
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    /**
     * 当前页
     */
    handleCurrentChange(val) {
      this.pageNo = val
      this.getList()
    },
    /**
     * 打开弹窗
     */
    openDia(item, e) {
      this.dialogVisible = true
      this.status = e ? e.a : null
      this.busId = item
      // console.log(item,e,'aaaaaaaa')
      this.getList()
    },
    
    /**
     * 获取列表
     */
    getList() {
      let params = {
        busId: this.busId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      this.$api.merchant.serveList(params).then(res => {
        res.data.data.list.map(obj => {
          obj.serveStatus = obj.status === 1 ? true : obj.status === 0 ? obj.status : false
          return
        })
        this.tableData = res.data.data.list
        this.total = res.data.data.total
      })
    },
    /**
     * 新增后刷新列表
     */
    refersh() {
      this.pageNo = 1
      this.getList()
    },
    /**
     * 关闭弹窗
     */
    handleCloseAdd() {
      if (this.status === 1) {
        this.dialogVisible = false
        return
      }
      this.dialogVisible = false
    },

    /**
     * 点击确认
     */
    submitForm() {
      if (this.status === 1) {
        this.dialogVisible = false
        return
      }
      this.dialogVisible = false
    },
    /**
     * 服务编辑
     */
    handleEdit(e) {
      let params = {
        goodsId: e.id
      }
      this.$api.merchant.serveDetail(params).then(res => {
        let item = {
          id: e.id,
          item: res.data.data,
        }
        this.$refs.newAdd.openDia(item)
      })

    },
    // 添加服务规格
    addServiceRules(e) {
      let item = e
      console.log(item,111)
      let param = {
        // 服务类目
        serviceId: e.id,
        //item: res.data.data,
      }
      // console.log(e.id,'jjjjjjj')
      this.$api.merchant.serviceSpecList(param).then(res => {
        console.log(res)
        if(res.data=[]){

        }
        this.$refs.AddServiceRule.openDia(item,res.data.data)
      //  console.log(res,'resresres')
      })
  },
  /**
    * 状态
    */
  changeStatus(e) {
    this.$confirm("此操作将更改数据状态, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      let params = {
        goodsId: e.id,
        busId: this.busId,
        typeId: e.serveStatus ? 1 : 0
      }
      this.$api.merchant.serveDown(params).then(res => {
        this.$message.success('状态更新成功')
        this.getList()
      }).catch(err => {
        // this.$message.warning(err.data.msg)
        e.serveStatus = !e.serveStatus
      })
    }).catch(() => {
      this.$message({
        type: "info",
        message: "已取消删除",
      });
      e.status = !e.status
    });

  },
  /**
    * 删除
    */
  del(e) {
    this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      let params = {
        goodsId: e.id,
        busId: this.busId,
      }
      this.$api.merchant.serveDel(params).then(res => {
        this.$message({
          type: "success",
          message: `已成功删除`,
        });
        this.getList()
      })
    }).catch(() => {
      this.$message({
        type: "info",
        message: "已取消删除",
      });
    });
  },
  /**
   * 新增
   */
  newAdd() {
    let item = {
      id: '',
      busId: this.busId
    }
    this.$refs.newAdd.openDia(item)
  }
}
};
</script>

<style  scoped>
.first-title {
  display: flex;
  align-items: center;
}

.first-title-icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-bottom: 10px;
  margin-right: 10px;
  background: #FF5722;
}

.first-title-word {
  flex: 1;
  box-sizing: border-box;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/businessListingServes.vue